import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledComparisonSlotDropdown = styled.div`
  .comparison-slot-dropdown__select {
    width: 100%;
    min-height: ${toRem(44)};
    border: ${toRem(1)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color.neutral40};
    border-radius: ${toRem(8)};
    background-color: ${baseVariables.color.base20};
    color: ${baseVariables.color.base10};
    cursor: pointer;
  }

  .comparison-slot-dropdown__select:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  .label {
    position: absolute;
    left: 10px;
    top: 15px;
    color: #707070 !important;
    transition: 0.2s ease all;
    pointer-events: none; /* Allows clicks to pass through to the dropdown */
    line-height: 1.2;
  }
  .dropdown-option {
    list-style: none;
    .t-font-s {
      color: ${baseVariables.color.neutral40};
      font-weight: 700;
    }
  }
  .dropdown-option:hover .t-font-s {
    color: ${baseVariables.color.base10};
  }
  .dropdown-options {
    padding-left: 0;
    border-radius: var(--General-spacer-02, 8px);
    background: var(--System-base-20, #fff);
    /* Light/Shadow-01 */
    box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 56px;
    width: 343px;
    right: 0;
    z-index: 10;
  }
  .select-wrapper {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    color: #1c1c1c;
    background-color: #ffffff;
    border: 1px solid #707070;
    border-radius: 0.5rem;
    padding: 1.875rem 1rem 0.625rem;
    height: 52px;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    padding: 1.2rem 1rem 0.625rem;
    padding-right: 3rem;
  }
  .option-image {
    height: ${toRem(38)};
  }
  .selected-option {
    color: ${baseVariables.color.neutral40};
  }
  .is-active .selected-option {
    color: ${baseVariables.color.base10};
  }
  .placeholder {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
